/** Directional glyphs: arrows and chevrons. */
import { IconBase, type IconProps } from "./Icon";

export function IconArrowRight(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M4 12h15M13 6l6 6-6 6" />
    </IconBase>
  );
}

export function IconArrowLeft(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M20 12H5M11 6l-6 6 6 6" />
    </IconBase>
  );
}

export function IconChevronDown(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5 9l7 7 7-7" />
    </IconBase>
  );
}

export function IconChevronUp(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5 15l7-7 7 7" />
    </IconBase>
  );
}
